import { render, staticRenderFns } from "./TextSwitchingLoader.vue?vue&type=template&id=6fd4e97c&scoped=true&"
import script from "./TextSwitchingLoader.vue?vue&type=script&lang=js&"
export * from "./TextSwitchingLoader.vue?vue&type=script&lang=js&"
import style0 from "./TextSwitchingLoader.vue?vue&type=style&index=0&id=6fd4e97c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd4e97c",
  null
  
)

export default component.exports